var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"result"},[_c('tbody',_vm._l((_vm.result),function(value,key){return _c('tr',{key:key},[_c('td',[_vm._v(_vm._s(key))]),_c('td',[_c('form-result-value-field',{attrs:{"value":value}})],1)])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }